import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import AddOrder from './views/AddOrder.vue'
import Order from './views/Order.vue'
import LoginCallback from './views/LoginCallback.vue'

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/add-order',
			name: 'AddOrder',
			component: AddOrder
		},
		{
			path: '/order/:orderId',
			name: 'order',
			params: ['orderId'],
			components: {
				default: Order,
			}
		},
		{
			path: '/callback',
			name: 'callback',
			component: LoginCallback
		}
	]
})


Vue.use(Router)